<div [formGroup]="icmsSnForm">

    <app-ativacao-section-card
        [control]="isAtivoControl"
        titulo="Simples Nacional"
        descricaoAtivo="Simples Nacional ativo. A regra padrão e as exceções abaixo serão aplicadas no cálculo desta natureza de operação."
        descricaoInativo="Simples Nacional inativo. Nenhum valor de ICMS do Simples Nacional será calculado nesta natureza de operação."
        emptyStateDescricao="Ative o Simples Nacional acima para configurar a regra padrão, as observações e as exceções deste tributo.">
    </app-ativacao-section-card>

    @if (isAtivoControl.value) {

    <!-- ── Regra Padrão ──────────────────────────────────────────────── -->
    <app-icms-sn-tributo-regra-section
        [form]="icmsSnForm"
        [csosns]="csosns"
        [modalidadesBc]="modalidadesBc"
        [modalidadesBcSt]="modalidadesBcSt"
        [cfopLookupUrl]="cfopLookupUrl"
        [personalizadasCount]="personalizadasCount"
        [personalizarDisabled]="formulasParaCsosn.length === 0"
        cfopControlName="cfopPadrao"
        [tipoOperacao]="tipoOperacaoValue"
        (personalizar)="abrirEditorFormulas()">
    </app-icms-sn-tributo-regra-section>

    <!-- ── Observações ────────────────────────────────────────────────── -->
    <app-icms-sn-tributo-observacoes-section
        [control]="$any(icmsSnForm.get('observacao'))"
        [variaveis]="icmsSnForm.get('csosn')?.value ? variaveisUnicas : []"
        titulo="Informações complementares"
        icone="notes"
        placeholder="Texto da observação que será impresso no documento fiscal..."
        (abrirVariaveis)="abrirVariaveisDisponiveis($event)">
    </app-icms-sn-tributo-observacoes-section>

    <!-- ── Informações adicionais ao fisco ───────────────────────────────────────── -->
    <app-icms-sn-tributo-observacoes-fisco-section
        [control]="$any(icmsSnForm.get('observacaoFisco'))"
        [variaveis]="icmsSnForm.get('csosn')?.value ? variaveisUnicas : []"
        (abrirVariaveis)="abrirVariaveisDisponiveis($event)">
    </app-icms-sn-tributo-observacoes-fisco-section>

    <!-- ── Exceções ───────────────────────────────────────────────────── -->
    <app-icms-sn-tributo-excecoes-section
        [idNaturezaOperacao]="idNaturezaOperacao"
        [csosns]="csosns"
        [cfopLookupUrl]="cfopLookupUrl"
        [modalidadesBc]="modalidadesBc"
        [modalidadesBcSt]="modalidadesBcSt"
        [variaveis]="variaveisUnicas"
        [formulasIcmsSn]="formulasIcmsSn"
        [tipoOperacao]="tipoOperacaoValue"
        [excecoesPendentes]="excecoesPendentes"
        (excecoesChange)="excecoesChange.emit($event)">
    </app-icms-sn-tributo-excecoes-section>

    }

</div>
